import React from 'react';
import { func } from 'prop-types';
import { Icon } from '@fiverr-private/fit';

import './style.scss';

const ActionIcon = ({ icon, onClick = Function.prototype }) => (
    <Icon className="action-icon" onClick={onClick}>
        {icon}
    </Icon>
);

ActionIcon.propTypes = {
    icon: func,
    onClick: func,
};

export default ActionIcon;
